import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Role } from '../../enums/role';
import { User } from '../../models/user';
import { Functions } from '../../utilities/functions';
import { Reset } from '../../utilities/reset';

@Component({
  selector: '[app-user-row]',
  imports: [
    FormsModule,
    CommonModule,
    ButtonModule,
    TranslatePipe,
    TagModule
  ],
  templateUrl: './user-row.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class UserRowComponent {
  @Input() user: User = Reset.user();
  @Input() maxRole: number = Role.patient;
  @Input() isShowing: boolean = false;

  deleteRequest = output<User>();
  showRequest = output<User>();

  showDisabled: boolean = false;


  ngOnChanges() {
    if (this.user !== undefined || this.user !== null) {
      const role = Math.min(...this.user.roles);
      this.showDisabled = role < this.maxRole;
    } else {
      this.showDisabled = false;
    }
  }

  getRoleName(role: number): string {
    return Functions.getRoleName(role);
  }

  getRoleSeverity(role: number) {
    return Functions.getRoleSeverity(role);
  }

  onDelete(event: Event): void {
    this.deleteRequest.emit(this.user);
  }

  onShowDialog(): void {
    this.showRequest.emit(this.user);
  }

}
